import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ACCEPTED_FORMATS, UPLOAD_TYPES } from 'src/models/UploadFileTypes';
import { CurrentUIState } from 'src/models/UIState';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { CurrentUiStoreService } from 'src/app/services/ui/current-ui-store.service';
import { ExamModeRestrictionsService } from 'src/app/services/exam/exam-mode-restrictions.service';
import { OpenFileAction, OpenFileService } from 'src/app/services/open-file.service';
import { TranslateModule } from '@ngx-translate/core';
import { MainClickDirectiveDirective } from '../../utils/directives/main-click-directive.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'asg-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    standalone: true,
    imports: [NgClass, MainClickDirectiveDirective, TranslateModule]
})
export class UploadFileComponent {
  TYPES = UPLOAD_TYPES;
  @Input() UPLOAD_TYPES: UPLOAD_TYPES = UPLOAD_TYPES.PDF;
  @Input() ACCEPTED_FORMATS: ACCEPTED_FORMATS = ACCEPTED_FORMATS.COMMON;
  @Input() ACTION: OpenFileAction;
  @Input() feature: AsgardFeatureNames = AsgardFeatureNames.OPEN_DOC;
  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef | null = null;

  get uiState(): CurrentUIState {
    return this.uiService.uiState.value;
  }

  public selectFile = () => {
    if (this.fileUpload) {
      this.examModeService.toggleFilePickerIsOpen(true);
      this.fileUpload.nativeElement.click();
    }
  }

  constructor(
    private uiService: CurrentUiStoreService,
    private readonly examModeService: ExamModeRestrictionsService,
    private readonly openFileService: OpenFileService
  ) { }

  public async uploadFile(e: Event): Promise<void> {
    this.examModeService.toggleFilePickerIsOpen(false);
    if (e.type === 'change') {
      const files: FileList | null = (e.target as HTMLInputElement).files;

      if (files === null) {
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);

        if (file instanceof File) {
          await this.openFileService.open(file, this.ACTION);
        }
      }

      if (e.target) {
        (e.target as HTMLInputElement).value = '';
      }
    }
  }
}
